/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { SdkDetails } from 'app/models/SdkDetails';

@Component({
  selector: 'app-sdk-details-apps',
  templateUrl: './app-sdk-details.component.html',
  styleUrls: ['./app-sdk-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSdkDetailsComponent implements OnInit {
  @Input() sdkDetails: SdkDetails[];

  ngOnInit(): void {}

  sortByField(field: string, sdkDetails: SdkDetails[]): SdkDetails[] {
    return sdkDetails.sort((a, b) => a[field].localeCompare(b[field]));
  }
}
